import * as Sentry from "@sentry/react";
import { shouldEnableFeature } from "./shouldEnableFeature";

export function logToSentry(
	msg: string,
	severity?: "fatal" | "error" | "warning" | "log" | "debug" | "info",
	args: unknown[] = [],
) {
	const shouldLogToSentry = shouldEnableFeature("useSentry");

	if (shouldLogToSentry) {
		Sentry.captureMessage(msg, severity);
	} else {
		log(msg, severity, args);
	}
}

export function log(
	msg: string,
	severity?: "fatal" | "error" | "warning" | "log" | "debug" | "info",
	...args: unknown[]
) {
	if (severity === "error") {
		// biome-ignore lint/suspicious/noConsole: logger is the designated console output point
		console.error(`[APP] [ERROR] ${msg}`, ...args);
	} else if (severity === "warning") {
		// biome-ignore lint/suspicious/noConsole: logger is the designated console output point
		console.warn(`[APP] [WARNING] ${msg}`, ...args);
	} else if (severity === "info") {
		// biome-ignore lint/suspicious/noConsole: logger is the designated console output point
		console.info(`[APP] [INFO] ${msg}`, ...args);
	} else {
		// biome-ignore lint/suspicious/noConsole: logger is the designated console output point
		console.log(`[APP] ${msg}`, ...args);
	}
}
